import { Component } from '@angular/core';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss']
})
export class ReviewsComponent {
  reviews = [
    {
      name: 'tatiana',
      category: 'animal_products',
      avatar: './assets/img/girl.jpg',
      text: `review_tatiana`
    },
    {
      name: 'andrew',
      category: 'makeup',
      avatar: 'assets/img/client-man.jpg',
      text: `review_andrew`
    },
    {
      name: 'christina',
      category: 'home_goods',
      avatar: 'assets/img/girl2.jpg',
      text: `review_christina`
    },
    {
      name: 'mary',
      category: 'promotional_goods',
      avatar: 'assets/img/girl3.jpg',
      text: `review_mary`
    },
    {
      name: 'ilya',
      category: 'toys',
      avatar: 'assets/img/il.png',
      text: `review_ilya`
    },
    {
      name: 'andrew',
      category: 'sports_goods',
      avatar: 'assets/img/client-man2.png',
      text: `review_andrew_another`
    }
  ];
}
